import React from 'react';

import HomePage from './pages/home/HomePage';

const Page404 = React.lazy(() => import('./pages/page404/Page404'));
const Page500 = React.lazy(() => import('./pages/page500/Page500'));

const ListingPage = React.lazy(() => import('./pages/listing/ListingPage'));
const ListingDetailPage = React.lazy(() => import('./pages/listing/ListingDetailPage'));

const GuidePage = React.lazy(() => import('./pages/guide/GuidePage'));
const BlogPage = React.lazy(() => import('./pages/blog/BlogPage'));
const ReviewPage = React.lazy(() => import('./pages/review/ReviewPage'));

const MyPage = React.lazy(() => import('./pages/mypage/MyPage'));
const MyNotifications = React.lazy(() => import('./pages/mypage/MyNotifications'));
const MyAccount = React.lazy(() => import('./pages/mypage/MyAccount'));
const MyBookings = React.lazy(() => import('./pages/mypage/MyBookings'));

const OrderDetail = React.lazy(() => import('./pages/order/OrderDetail'));

const ReservationDetailPage = React.lazy(() => import('./pages/reservation/ReservationDetailPage'));

const ShortlistPage = React.lazy(() => import('./pages/shortlist/ShortlistPage'));

const OrderPage = React.lazy(() => import('./pages/order/OrderPage'));
const OrderCompletePage = React.lazy(() => import('./pages/order/OrderCompletePage'));

const CartsPage = React.lazy(() => import('./pages/carts/CartsPage'));

const routes = [
  { path: '/', element: HomePage },
  { path: '/listing', element: ListingPage },
  { path: '/listing/:id', element: ListingDetailPage },
  { path: '/blog', element: BlogPage },
  { path: '/guide', element: GuidePage },
  { path: '/reviews', element: ReviewPage },
  // {path: '/my', element: MyOrderHistory},
  {
    path: '/my',
    element: MyPage,
    children: [
      { path: 'bookings', element: MyBookings },
      { path: 'notifications', element: MyNotifications },
      { path: 'account', element: MyAccount },
    ],
  },
  { path: '/shortlist', element: ShortlistPage },
  { path: '/order', element: OrderPage },
  { path: '/order/:orderId', element: OrderDetail },
  { path: '/order/complete', element: OrderCompletePage },
  { path: '/reservation/:id', element: ReservationDetailPage },
  { path: '/carts', element: CartsPage },
  { path: '/404', element: Page404 },
  { path: '/500', element: Page500 },
];

export default routes;
